import { RoomListItem } from '@spike/appointments-list-model';
import { getAvailableByPetIdThunk } from '@spike/rooms-action';
import { useApiClientWrapper } from 'hooks';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import styles from './RoomSelector.module.scss';
import EditableRoomChip from './UI/EditableRoomChip';

interface RoomSelectorProps {
    petId: number;
    serviceId: number;
    dropOffRoom: string;
    PickUpRoom: string;
    room?: RoomListItem | null;
    className?: string;
    fullWidth?: boolean;
    scrollerContainerId?: string;
    editable?: boolean;
    onChange?: (unitRoomId: number | null) => void;
}

export const RoomSelector: FunctionComponent<RoomSelectorProps> = props => {
    const dispatch = useDispatch();
    const apiClientWrapper = useApiClientWrapper();

    const handlerExpanded = () => {
        dispatch(
            getAvailableByPetIdThunk(
                apiClientWrapper,
                props.petId,
                props.serviceId!,
                props.dropOffRoom!,
                props.PickUpRoom!
            )
        );
    };

    return (
        <div className={styles.roomContainer}>
            <div className={styles.chipContainer}>
                <EditableRoomChip
                    selectedRoom={props.room}
                    onSelectRoom={(roomUnitId: number | null) => props.onChange && props.onChange(roomUnitId)}
                    maxWidthButton={props.fullWidth || false}
                    scrollerContainerId={props.scrollerContainerId}
                    editable={props.editable}
                    onExpanded={handlerExpanded}
                />
            </div>
        </div>
    );
};

export default RoomSelector;
